import axiosInstance from '../../../helpers/axios';

const getCountries = () => {
  return axiosInstance.get('country/get_by_query?pageno=1&limit=1000');
};

export default getCountries;
